import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = '/api';

/**
 * Analytics tracker component
 * Automatically tracks page views when route changes
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    // Don't track admin pages or duplicate paths
    if (location.pathname.startsWith('/admin')) return;
    if (location.pathname === lastPath.current) return;
    
    lastPath.current = location.pathname;

    const trackPageView = async () => {
      try {
        await axios.post(`${API}/analytics/pageview`, {
          path: location.pathname,
          referrer: document.referrer || '',
          title: document.title,
          screen_width: window.screen.width,
          screen_height: window.screen.height
        });
      } catch (error) {
        // Silently fail - analytics should not break the app
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Small delay to ensure page has loaded
    const timer = setTimeout(trackPageView, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;
